import { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useCursor } from "../../context/CursorContext";

export default function MobileContactButton() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setIsLightCursor } = useCursor();
  const [visible, setVisible] = useState(false);
  const [open, setOpen] = useState(location.pathname === "/contact");
  const blockingRef = useRef(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 80);
    return () => clearTimeout(t);
  }, []);

  /* Sync open state when route changes externally */
  useEffect(() => {
    if (location.pathname === "/contact") {
      setOpen(true);
    }
  }, [location.pathname]);

  /* Listen for closeContact so the rotation starts immediately */
  useEffect(() => {
    const handler = () => {
      setOpen(false);
    };
    window.addEventListener("closeContact", handler);
    return () => window.removeEventListener("closeContact", handler);
  }, []);

  const handleClick = () => {
    if (blockingRef.current) return;
    if (open) {
      setOpen(false);
      window.dispatchEvent(new CustomEvent("closeContact"));
    } else {
      blockingRef.current = true;
      setOpen(true);
      setIsLightCursor(true);
      navigate("/contact");
      setTimeout(() => { blockingRef.current = false; }, 500);
    }
  };

  return (
    <div className="lg:hidden fixed top-5 right-6 z-[70] pointer-events-none">
      <button
        onClick={handleClick}
        className="pointer-events-auto cursor-pointer bg-transparent border-none outline-none w-10 h-10 flex items-center justify-center"
        aria-label={open ? "Fechar contactos" : "Abrir contactos"}
        style={{
          fontSize: "32px",
          fontWeight: 300,
          lineHeight: 1,
          fontFamily: "'Inter', sans-serif",
          color: open ? "#eaeaeb" : "#000",
          transform: `rotate(${open ? 45 : 0}deg) ${visible ? "translateY(0)" : "translateY(-18px)"}`,
          opacity: visible ? 1 : 0,
          transition: [
            "transform 0.42s cubic-bezier(0.76, 0, 0.24, 1)",
            "color 0.35s ease",
            "opacity 0.32s ease",
          ].join(", "),
        }}
      >
        +
      </button>
    </div>
  );
}
